
<template>
	<vButton v-if="isButton" v-bind="data" @click.native="handleOperate">{{getCompatibleLabel}}</vButton>
	<router-link
		v-else-if="data.to"
		:to="data.to"
		v-bind="data"
		data-vview-module="DropdownItem"
	>{{getCompatibleLabel}}</router-link>
	<a v-else-if="data.href" v-bind="data" data-vview-module="DropdownItem">{{getCompatibleLabel}}</a>
	<div
		v-else
		v-bind="data"
		data-vview-module="DropdownItem"
		@click="handleOperate"
	>{{getCompatibleLabel}}</div>
</template>

<script>
export default {
	props: ['data', 'isButton'],
	computed: {
		//兼容老代码name属性
		getCompatibleLabel() {
			return this.data.langKey ? $t(this.data.langKey, { defaultValue: this.data.name || this.data.label }) : (this.data.name || this.data.label)
		},
	},
	methods: {
		handleOperate() {
			this.$emit('on-click', this.data.params, this.data.operate, this.data.batch);
		},
	},
}
</script>